import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { FIELD_PATH_LOOK_FOR_AGE_RANGE } from 'components/page/DatingProfile/DatingProfile.constants'
import { ProfileFieldType } from 'components/page/ProfileCommon/ProfileCommon.types'
import { ProfileFieldGeneric } from 'components/page/ProfileCommon/ProfileField/ProfileFieldGeneric'
import { LookForAgeActiveSvg } from 'components/presentational/svg/LookForAgeActiveSvg'
import { GQLAgeRange } from 'generated-graphql/graphql'

interface ProfileLookForAgeProps {
  data: GQLAgeRange | undefined
}

export const ProfileLookForAge: FC<ProfileLookForAgeProps> = ({ data }) => {
  const searchAge =
    data?.from === data?.to ? data?.from : `${data?.from} - ${data?.to}`

  return (
    <ProfileFieldGeneric
      iconActive={<LookForAgeActiveSvg />}
      description={<FormattedMessage id="in.age" defaultMessage="В возрасте" />}
      data-name={FIELD_PATH_LOOK_FOR_AGE_RANGE}
      fieldType={ProfileFieldType.WithTitleWithoutLexeme}
      data={searchAge}
      showDescriptionIfActive={true}
    />
  )
}
